import freePassFetch from './freePassFetch';
import type {
  Promo,
  PromoItem,
  PromoItemStatus,
  PromoItemsResponse,
  PromoJourney,
} from '../types';

export const getActualPromos = async (): Promise<Promo[]> => {
  const response = await freePassFetch<{ promos: Promo[]; total: number }>(
    '/promos/actual'
  );
  return response.promos ?? [];
};

export const getPromoItems = (promoId: string): Promise<PromoItemsResponse> =>
  freePassFetch(`/user-promos/promos/${encodeURIComponent(promoId)}/items`);

export const participatePromo = (
  promoId: string
): Promise<{ journey: PromoJourney }> =>
  freePassFetch('/user-promos/participate', {
    method: 'POST',
    body: { promoId },
  });

export const claimPromoItem = (
  promoId: string
): Promise<{ status: PromoItemStatus; item: PromoItem }> =>
  freePassFetch('/user-promos/claim', {
    method: 'POST',
    body: { promoId },
  });
